export default {
  namespaced: true,
  state: () => ({
    produtos: {},
    setIsLoading: false,
    filterList: {},
  }),
  actions: {},
  mutations: {
    SET_PRODUTOS(state, data) {
      state.produtos = data;
    },
    SET_IS_LOADING(state, data) {
      state.setIsLoading = data;
    },
    SET_FILTROS(state, data) {
      state.filterList = data;
    },
  },
  getters: {
    getPodutos: (state) => state.produtos,
    getIsLoading: (state) => state.setIsLoading,
    getFilterList: (state) => state.filterList,
  },
};
